const state = {
    user_logged: false,
    email: null,
    user_data: null,
    access_token: null,
};

const mutations = {
    SET_USER_INFO(state, { email, user_data, access_token }) {
        state.user_logged = true;
        state.email = email;
        state.user_data = user_data;
        state.access_token = access_token;
    },
    ERASE_USER_INFO(state) {
        state.user_logged = false;
        state.email = null;
        state.user_data = null;
        state.access_token = null;
    },
};

const getters = {
    get_user_data(state) {
        return state;
    },
};

const actions = {
    async login({ commit }, { email, cpf, phone, password, rememberMe = false }) {
        const { ct_users } = await import('@/controllers/users');

        const response = await ct_users.signIn({ email, cpf, phone, password, rememberMe });
        if (!response.status) throw response.error;

        const profile = await ct_users.getProfile(response.access_token);
        if (!profile.status) throw profile.error;

        commit('SET_USER_INFO', {
            email,
            user_data: profile.data,
            access_token: response.access_token,
        });
    },

    async register({ dispatch }, payload) {
        const { ct_users } = await import('@/controllers/users');

        const response = await ct_users.signUp(payload);
        if (!response.status) throw response.error;

        if (response.code_mail) return { code_mail: true };

        await dispatch('login', { email: payload.email, password: payload.password });
        return { code_mail: false };
    },

    logout({ commit }) {
        commit('ERASE_USER_INFO');
        commit('account/RESET_ACCOUNT_STATE', null, { root: true });
        commit('meta/RESET_META_STATE', null, { root: true });
    },
};

const user = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};

export default user;
